// extracted by mini-css-extract-plugin
export default {"optionsWrap":"BirthdaysMenu_optionsWrap__5wVcy","name":"BirthdaysMenu_name__1vkrI"};